(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["psb-brand-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('psb-brand-carousel')) {
    customElements.define('psb-brand-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.psb-brands__track');
        this.pause = this.querySelector('[data-pause]');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.hovered = false;
        this.visible = false;
        this.holdUntil = 0;
        this.classList.add('is-ready');
        this.updateLabel();
        this.pause.addEventListener('click', () => { this.paused = !this.paused;this.updateLabel(); }, options);
        this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => { this.holdUntil = Date.now() + 8000;this.move(Number(button.dataset.direction)); }, options));
        this.addEventListener('mouseenter', () => { this.hovered = true; }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; }, options);
        this.track.addEventListener('pointerdown', () => { this.holdUntil = Date.now() + 10000; }, options);
        this.track.addEventListener('wheel', () => { this.holdUntil = Date.now() + 8000; }, options);
        this.motion.addEventListener('change', () => { if (this.motion.matches) { this.paused = true;this.updateLabel(); } }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
        this.observer.observe(this);
        this.timer = setInterval(() => {
          if (!this.paused && !this.hovered && this.visible && !document.hidden && !this.contains(document.activeElement) && Date.now() > this.holdUntil) this.move(1);
        }, 4000);
      }
      updateLabel() { this.pause.textContent = this.paused ? this.pause.dataset.playLabel : this.pause.dataset.pauseLabel; }
      move(direction) {
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (max < 2) return;
        const step = this.track.children[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
        let next = this.track.scrollLeft + direction * step;
        const wrap = (direction > 0 && this.track.scrollLeft >= max - 3) || (direction < 0 && this.track.scrollLeft <= 3);
        if (wrap) next = direction > 0 ? 0 : max;
        this.track.scrollTo({ left: next, behavior: wrap || this.motion.matches ? 'auto' : 'smooth' });
      }
      disconnectedCallback() { clearInterval(this.timer);this.observer?.disconnect();this.events?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
